import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { fetchProfileList, deleteProfile, fetchProfileById } from 'redux/profiles/ProfilesActions';
import ImportProfileGrid from "./ImportProfileGrid";

const mapStateToProps = state => ({
  profilesListGridData: state.profiles.profilesListGridData,
});

const mapDispatchToProps = dispatch => ({
  profileActions: bindActionCreators({ fetchProfileList, deleteProfile, fetchProfileById }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ImportProfileGrid));




// WEBPACK FOOTER //
// ./src/components/importData/comp/selectImportProfilePanel/comp/importProfileGrid/ImportProfileGridConnector.js